export const tooltipStyles = {
  padding: '24px',
  maxWidth: 'none',
  fontSize: '1.4rem',
  color: ({ palette }) => palette.text.primary,
  backgroundColor: ({ palette }) => palette.background.paper,
  borderRadius: '8px',
  boxShadow: '5px 0px 12px 0px #00000026, 0px 5px 12px 0px #00000026',
};

export const titleTypographyStyles = {
  marginBottom: '12px',
  fontSize: '1.8rem',
  fontWeight: 600,
  lineHeight: '2.1rem',
  color: ({ palette }) => palette.text.primary,
};

export const tableContainerStyles = {
  border: '1px solid',
  borderColor: `#EEEEEE !important`,
  borderRadius: '8px',
};

const commonCellStyles = {
  width: '160px',
  fontSize: '1.4rem',
  borderColor: `#EEEEEE !important`,

  '&:nth-of-type(2)': {
    width: '296px',
  },
};

export const tableHeadStyles = {
  '& .table-cell': {
    ...commonCellStyles,

    padding: '6px 15px',
    fontWeight: 700,
    lineHeight: '2.2rem',
    color: ({ palette }) => palette.text.primary,
  },
};

export const tableBodyStyles = {
  '& .table-cell': {
    ...commonCellStyles,

    padding: '4px 15px',
    fontWeight: 400,
    lineHeight: '2.2rem',
    color: ({ palette }) => palette.text.secondary,
  },

  '& .table-row:last-of-type .table-cell': {
    border: 'none',
  },
};
